import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";

const buttonStyles = {
  width: "100%",
  padding: "9px 14px",
  fontWeight: "600",
  fontSize: "13px",
  background: "linear-gradient(135deg, #e11d48 0%, #be123c 100%)",
  border: "none",
  borderRadius: "8px",
  margin: "6px 0",
  color: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  cursor: "pointer",
  boxShadow: "0 2px 8px rgba(225, 29, 72, 0.25)",
  transition: "all 0.2s ease",
};

function MapButton({ latitude, longitude }) {
  const openGoogleMaps = (e) => {
    e?.stopPropagation();
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

    // Installed as a standalone PWA, window.open either navigates this window
    // away from the app or opens one that never paints, which reads as a white
    // screen with no way back. A synthetic anchor click hands the URL to the
    // system browser and leaves the PWA untouched.
    const link = document.createElement("a");
    link.href = mapUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button onClick={openGoogleMaps} style={buttonStyles} aria-label="Open location in Google Maps">
      <EnvironmentOutlined style={{ fontSize: "14px", color: "#ffffff" }} />
      <span style={{ color: "#ffffff", fontWeight: "600" }}>Go to Maps</span>
    </button>
  );
}

export default MapButton;
